// extracted by mini-css-extract-plugin
module.exports = {"featured":"Featured_featured__1M4p6","featuredbox":"Featured_featuredbox__36fVm"};